import { createUseStyles } from "react-jss";
export const useStyles = createUseStyles({
  formGrp: {
    textAlign: "left",
    marginBottom: "10px",
    display: "flex",
    flexDirection: "column",
    "& .text-danger": {
      color: "#f34249",
    },
    "& .fgBox": {
      display: "flex",
      flexDirection: "column",
      "& input": {
        border: "1px solid var(--blackOpacity10)",
        width: "100%",
        minHeight: "40px",
        padding: "10px",
        fontWeight: "var(--fontWeight700)",
        "&:focus-visible": {
          outline: "none",
        },
      },
    },
  },
});
